import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import { CenteredCustomTypography } from '../custom-material/typography/Typography'
import CustomButton, { CancelCustomButton, OkDialogButton } from '../custom-material/button/Button'

const styles = theme => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 100px'
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '70%'
  }
})

class DeactivateUsersDialogComponent extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {isConfirmed: false}

    this.setIsConfirmed = () => this.setState({isConfirmed: true})
  }

  render () {
    const { isConfirmed } = this.state
    const { classes, dialogOpen, contactsToDeactivate, handleCloseDialog, handleConfirmDialog, saveDeactivate } = this.props
    return (
      <CustomDialog open={dialogOpen} onClose={handleCloseDialog} aria-labelledby='updates-dialog-title'>
        <CustomDialogTitle id='updates-dialog-title' disableTypography>Request to Deactivate User</CustomDialogTitle>
        <div className={classes.contentContainer}>
          <CenteredCustomTypography variant='body1' paragraph>
            {isConfirmed
            ? <span>You have successfully requested to have the following user(s) <strong>deactivated</strong>:</span>
            : <span>Please confirm you would like to request to have the following user(s) <strong>deactivated</strong>:</span>}
          </CenteredCustomTypography>
          {contactsToDeactivate.map((x, i) => <CenteredCustomTypography key={i} variant='body1'>{x.firstName} {x.lastName}</CenteredCustomTypography>)}<br />
          {isConfirmed ? null : <CenteredCustomTypography variant='body1' paragraph>Do you want to continue?</CenteredCustomTypography>}
          <br />
          <div className={classes.actionContainer}>
            {isConfirmed
            ? <OkDialogButton variant='contained' size='small' color='secondary' onClick={handleConfirmDialog} style={{marginRight: '-55%'}}>OK</OkDialogButton>
            : <React.Fragment>
              <CancelCustomButton variant='contained' size='small' color='default' onClick={handleCloseDialog}>Cancel</CancelCustomButton>
              <CustomButton variant='contained' size='small' color='secondary' onClick={() => { saveDeactivate(); this.setIsConfirmed() }}>Yes</CustomButton>
            </React.Fragment>
            }
          </div>
        </div>
      </CustomDialog>
    )
  }
}

DeactivateUsersDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool,
  contactsToDeactivate: PropTypes.array,
  handleCloseDialog: PropTypes.func,
  handleConfirmDialog: PropTypes.func,
  saveDeactivate: PropTypes.func
}

export default withStyles(styles)(DeactivateUsersDialogComponent)
